import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const EsignSetBrandingInputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-palette', title: 'E-Sign Set Branding', subtitle: 'Configure brand name and logo for e-sign requests' }}
        fileFields={[
            { name: 'brand_image', label: 'Brand Logo', accept: 'image/*', maxSizeBytes: 2 * 1024 * 1024, hint: 'JPG / PNG up to 2 MB', required: false, colClass: 'col-12 md:col-6' },
        ]}
        textFields={[
            { name: 'brand_name', label: 'Brand Name', icon: 'pi-tag', placeholder: 'Your brand name', maxLength: 100, colClass: 'col-12 md:col-6' },
            { name: 'brand_image_url', label: 'Brand Logo URL (optional)', icon: 'pi-link', placeholder: 'https://example.com/logo.png', maxLength: 500, autoCapitalize: 'none', spellCheck: false, required: false, colClass: 'col-12 md:col-6' },
        ]}
        endpoint={{ path: '/surepass/esign/set-branding' }}
        consentReportType="esign-set-branding"
        submitLabel="Set Branding"
        successSummary="Branding set"
        errorSummary="Branding update failed"
        confirmHeader="Confirm branding update"
        confirmAcceptLabel="Yes, save"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'E-Sign Branding', icon: 'pi-palette' }}
    />
);

export default EsignSetBrandingInputComponent;
